import { styled } from '@mui/material/styles';

import landingImage from 'src/assets/images/assist-login-banner.png';
import image from 'src/assets/images/login-july2025.svg';

interface LandingPageImageProps {
  assistLogin?: boolean;
}

const LandingPageImage = ({ assistLogin }: LandingPageImageProps) =>
  assistLogin ? <StyledImageAssist /> : <StyledImage />;

const StyledImageAssist = styled('div')`
  flex: 1;
  background-image: url(${landingImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: rgb(18, 32, 44);
  width: 100%;
  height: 100%;
`;

const StyledImage = styled('div')`
  flex: 1;
  background-image: url(${image});
  background-size: auto;
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${({ theme }) => theme.palette.colors.primary[800]};
  width: 100%;
  height: 100%;
`;

export default LandingPageImage;
